import { ref } from 'yup';
import axios from '../../api/axios';
import { Types } from '../actionTypes';
import { LogoutUser} from './LoginActions';


const SaveToken = token => ({
  type: Types.SAVE_USER_TOKEN,
  payload: token
});

const DelToken = () => ({
  type: Types.DEL_USER_TOKEN,
  payload: ''
});


const UseRefreshToken = token => ({
  type: Types.USE_REFRESH_TOKEN,
  payload: token
});


let axiosConfig = {
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
  }
};

export const saveToken = (token) => {
  return dispatch => {
    dispatch(SaveToken(token));
  }
};

export const delToken = () => {
  return dispatch => {
    dispatch(DelToken());
  }
};

export const  useRefreshToken = (ref_token) => {
  //var form_data = new FormData();
  //form_data.append("jsondata", JSON.stringify({ token: ref_token }));

  return async dispatch => {
     //await axios.post("api/user/refresh", form_data, axiosConfig)
     // .then(res => {
     //    dispatch(UseRefreshToken(res.data.access_Token));
     // })
     // .catch(error => {
     //   console.log(error);
     //   if (error.response.status===401)
     //   {
     //     dispatch(LogoutUser(null));
     //   }
    // });
    if (ref_token)
      dispatch(UseRefreshToken(ref_token));
    else
      dispatch(LogoutUser(null));
  };
};
